import { StatusBar } from "expo-status-bar";
import React from "react";
import { Helmet } from "react-helmet";
import { ImageBackground, Platform, Text, View } from "react-native";
import {
  heightPercentageToDP as hpd,
  widthPercentageToDP as wpd,
} from "react-native-responsive-screen";
import Footer_web from "../components/footer_web";
import StyledButton from "../components/StyledButton";
import strings from "./../assets/strings/hardCodedStrings.json";
import {
  androidTitle,
  Colors,
  globalStyles,
  iOSTitle,
  textLineSpacingMultiplier,
  Typography,
  webSubTitlePercent,
  webTextPercent,
} from "./../global";

export default function homeScreen({ navigation }) {
  return (
    <>
      {Platform.OS == "web" ? (
        <ImageBackground
          resizeMode="cover"
          style={{ height: "100%", width: "100%" }}
          source={require("../assets/cliparts/background-01.webp")}
        >
          <Helmet>
            <meta
              name="description"
              content={strings.seo_meta.home_page.description}
            />
          </Helmet>
          <View
            style={[
              globalStyles.centeredContentContainerWeb,
              { backgroundColor: null },
            ]}
          >
            <View
              style={{
                //   flexWrap: "wrap",
                width: "100%",
                marginVertical: "auto",
                alignItems: "center",
              }}
            >
              <ImageBackground
                resizeMode="contain"
                style={{
                  height: hpd(40),
                  width: wpd(40),
                  marginBottom: wpd(webTextPercent),
                }}
                source={require("../assets/coloredLogo.webp")}
              />

              <Text
                style={[
                  Typography.subTitle,
                  {
                    paddingBottom: wpd(webTextPercent),
                  },
                ]}
              >
                {strings.home_page.text_slogan}
              </Text>
              <Text
                style={[
                  Typography.arabicText,
                  {
                    paddingBottom: wpd(webSubTitlePercent),
                  },
                ]}
              >
                {strings.home_page.text_details}
              </Text>
              <StyledButton
                gray
                title={strings.home_page.button_start_journey}
                onPress={() => navigation.navigate("Main Filter")}
                linkTo="/mainFilter"
              />
            </View>
            {Platform.OS == "web" && (
              <View style={{ flexWrap: "wrap", width: "100%" }}>
                <Footer_web />
              </View>
            )}
          </View>
        </ImageBackground>
      ) : (
        <View style={globalStyles.centeredContentContainer}>
          {/* <StatusBar style="auto" /> */}
          <StatusBar style={"dark"} />
          <Text
            style={[
              Typography.title,
              {
                ...Platform.select({
                  android: {
                    fontSize: androidTitle * 1.5,
                    lineHeight: androidTitle * 1.5 * textLineSpacingMultiplier,
                  },
                  ios: {
                    fontSize: iOSTitle * 1.5,
                    lineHeight: iOSTitle * 1.5 * textLineSpacingMultiplier,
                  },
                }),
                color: Colors.black,
                textAlign: "center",
              },
            ]}
          >
            {strings.home_page.text_welcome}
          </Text>
          <Text
            style={[
              Typography.title,
              {
                ...Platform.select({
                  android: {
                    fontSize: androidTitle * 2,
                  },
                  ios: {
                    fontSize: iOSTitle * 2,
                  },
                }),
              },
            ]}
          >
            {strings.home_page.text_daleluk}
          </Text>
          <StyledButton
            gray
            title={strings.home_page.button_start_journey}
            onPress={() => navigation.navigate("Main Filter")}
          />
          <StyledButton
            gray
            title={strings.home_page.button_about_us}
            onPress={() => navigation.navigate("About Us")}
          />
        </View>
      )}
    </>
  );
}
